import VerifyEmail from 'src/features/auth/components/VerifyEmail';
import { useAuth } from 'src/features/auth/contexts/AuthContext';

export default function VerifyEmailPage() {
  const { logout } = useAuth();

  return (
    <VerifyEmail
      redirectUrl="/plugins/outlook/login"
      dashboardUrl="/plugins/outlook/taskpane"
      className="w-full"
      logout={logout}
    />
  );
}
